import Vue from 'vue'
import Router from 'vue-router'
import page404 from '@/components/404'

let APP_WEB_SUBPATH = '/app342'

const customAppPageEditor  = () => import(  "@/components/customAppMaker/pageEditor");
const innerAppShow = () => import( '@/components/amis/AMisAppLoader')

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'ADPStartPage',
      component: page404,
    },{
      path: APP_WEB_SUBPATH + '/customAppPageEditor',
      name: 'customAppPageEditor',
      component: customAppPageEditor,

    },{
      path: '/innerApp/*',
      name: 'innerApp',
      component: innerAppShow
    },{
      path: '/innerApp_dev/*',
      name: 'innerApp_dev',
      component: innerAppShow
    },
    {
      path: '*',
      component:page404
    }
  ]
})


